<template>
<div>
  <h1 class="lesson-title">Search: <small>{{text}}</small></h1>
    <p v-if="!total">No results</p>
    <a class="search-item" :key="`item-${index}`" v-for="(item, index) in list.search" @click="onClick(item)">Lesson {{item.lessonId}} - {{item.name}} <span>{{item.intro.substring(0, 140)}}</span> </a>
    <Pagination :current="list.pagination.current_page" :total="total" @onPageChanged="toPage" v-if="total > 1"></Pagination>
  </div>
</template>

<script>

import Pagination from '@/components/Pagination'
import ManualService from '@/services/ManualService'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      list: this.content
    }
  },
  watch: {
    content: function (val) {
      this.list = val
    }
  },
  computed: {
    total: function () {
      return Math.ceil(this.list.pagination.total / 20)
    }
  },
  methods: {
    onClick: function (item) {
      const termsSlug = ['nursery-pre-school', 'pre-kindergarten', 'kindergarten']

      let params = {
        section: termsSlug[ item.term - 1 ],
        unit: item.unit,
        week: item.week,
        lesson: item.id
      }

      this.$router.push({ name: 'manualContent', query: { lang: this.$route.query.lang || 1, s: this.text }, params: params })
    },
    toPage (page) {
      if (page > 0 && page <= this.total) {
        let options = this.filters
        options.search = this.text
        options.page = page

        ManualService.getSearch(options).then((search) => {
          this.list = search
        })
      }
    }
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    filters: {
      type: Object
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.search-item{
  display: block;
  padding-bottom: 1rem;
  span{
    display: block;
    color: #666;
  }
}

.lesson-title {
  margin-bottom: 1.2rem;
  text-transform: uppercase;
  font-size: 2.5rem;
  line-height: 3rem;
  font-weight: bold;

  small{
    text-transform: none;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/ManualSearchContent.vue